import { ProductionMaterialsPage } from '@/pages/ProductionMaterialsPage';
import { ProductionExecutionPage } from '@/pages/ProductionExecutionPage';
import { ProductionExecutionDocumentPage } from '@/pages/ProductionExecutionDocumentPage';
import { ProductionExecutionListPage,InspectionDetailPage } from '@/pages/ProductionExecutionListPage';
import { QualitySpecsPage,QualitySpecEditorPage } from '@/pages/QualitySpecsPage';
import { ProductionMaterialPage } from '@/pages/ProductionMaterialPage';
import { ProductionPage,ProductionResourcesPage } from '@/pages/ProductionPage';
import { ProductionResourcePage } from '@/pages/ProductionResourcePage';
import { ProductionEditorPage } from '@/pages/ProductionEditorPage';
import { SourcingProgressPage } from '@/pages/SourcingProgressPage';
import { SourcingPage } from '@/pages/SourcingPage';
import { SourcingEditorPage } from '@/pages/SourcingEditorPage';
import { SourcingBidPage } from '@/pages/SourcingBidPage';
import { SourcingOrderPage } from '@/pages/SourcingOrderPage';
import { MrpRunsPage,MrpRunPage } from '@/pages/MrpRunsPage';
import { MrpPage } from '@/pages/MrpPage';
import { UnitPricingPage } from '@/pages/UnitPricingPage';
import { UnitPricingEditorPage } from '@/pages/UnitPricingEditorPage';
import {OpportunitiesPage,OpportunityEditorPage} from '@/pages/OpportunitiesPage';
import { SalesOrdersPage } from '@/pages/SalesOrdersPage';
import { SalesOrderEditorPage } from '@/pages/SalesOrderEditorPage';
import { RequisitionsPage } from '@/pages/RequisitionsPage';
import { RequisitionEditorPage } from '@/pages/RequisitionEditorPage';
import { RoutingsPage } from '@/pages/RoutingsPage';
import { RoutingEditorPage } from '@/pages/RoutingEditorPage';
import { BomsPage } from '@/pages/BomsPage';
import { BomEditorPage } from '@/pages/BomEditorPage';
import { StockTransfersPage } from '@/pages/StockTransfersPage';
import { StockReservationsPage } from '@/pages/StockReservationsPage';
import { StockCountsPage } from '@/pages/StockCountsPage';
import { StockSalesPage } from '@/pages/StockSalesPage';
import { StockTransferEditorPage } from '@/pages/StockTransferEditorPage';
import { QualityPage } from "@/pages/QualityPage";
import { NcrPage } from "@/pages/NcrPage";
import { FinancePage } from "@/pages/FinancePage";
import { KpisPage } from "@/pages/KpisPage";
import { PProcessPage } from "@/pages/PProcessPage";
import { OrderProcessPage } from "@/pages/OrderProcessPage";
import { PortalPage } from "@/pages/PortalPage";
import { DevicesPage } from "@/pages/DevicesPage";
import { SubcontractOrderPage } from "@/pages/SubcontractOrderPage";
import { SubcontractPage } from "@/pages/SubcontractPage";
import { IqcEditorPage } from "@/pages/IqcEditorPage";
import { WarehousePage } from "@/pages/WarehousePage";
import { WarehouseLocationsPage } from "@/pages/WarehouseLocationsPage";
import { WarehouseReceiptPage } from "@/pages/WarehouseReceiptPage";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { RequireAuth } from "@/components/shell/RequireAuth";
import { AppLayout } from "@/components/shell/AppLayout";
import { LoginPage } from "@/pages/LoginPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { CustomersPage } from "@/pages/CustomersPage";
import { CustomerEditorPage } from "@/pages/CustomerEditorPage";
import { CustomerDetailPage } from "@/pages/CustomerDetailPage";
import { ProformaInvoicesPage } from "@/pages/ProformaInvoicesPage";
import { RedPiPage } from "@/pages/RedPiPage";
import { ProformaInvoiceDetailPage } from "@/pages/ProformaInvoiceDetailPage";
import { ProformaInvoiceEditorPage } from "@/pages/ProformaInvoiceEditorPage";
import { InvoicesPage } from "@/pages/InvoicesPage";
import { InvoiceEditorPage } from "@/pages/InvoiceEditorPage";
import { InvoiceDetailPage } from "@/pages/InvoiceDetailPage";
import { StatementPage } from "@/pages/StatementPage";
import { PurchaseOrdersPage } from "@/pages/PurchaseOrdersPage";
import { PurchaseOrderEditorPage } from "@/pages/PurchaseOrderEditorPage";
import { PackingListsPage } from "@/pages/PackingListsPage";
import { PackingListDetailPage } from "@/pages/PackingListDetailPage";
import { PackingListEditorPage } from "@/pages/PackingListEditorPage";
import { DeliveryNotesPage } from "@/pages/DeliveryNotesPage";
import { DeliveryNoteDetailPage } from "@/pages/DeliveryNoteDetailPage";
import { DeliveryNoteEditorPage } from "@/pages/DeliveryNoteEditorPage";
import { AnalyticsPage } from "@/pages/AnalyticsPage";
import { ProfitPage } from "@/pages/ProfitPage";
import { PiStatusPage } from "@/pages/PiStatusPage";
import { SampleOrdersPage } from "@/pages/SampleOrdersPage";
import { SampleOrderEditorPage } from "@/pages/SampleOrderEditorPage";
import { SampleCardEditorPage } from "@/pages/SampleCardEditorPage";
import { SampleCardDetailPage } from "@/pages/SampleCardDetailPage";
import { SampleCardsPage } from "@/pages/SampleCardsPage";
import { DeletedRecordsPage } from "@/pages/DeletedRecordsPage";
import { ComingSoonPage } from "@/pages/ComingSoonPage";
import { ServiceTicketsPage,ServiceTicketEditorPage } from "@/pages/ServiceTicketsPage";
import { SupplierClaimsPage, SupplierClaimEditorPage } from "@/pages/SupplierClaimsPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { ProductsPage } from "@/pages/ProductsPage";
import { ProductEditorPage } from "@/pages/ProductEditorPage";
import { ProductStockPage } from "@/pages/ProductStockPage";
import { ProductDetailPage } from "@/pages/ProductDetailPage";
import { SuppliersPage } from "@/pages/SuppliersPage";
import { SupplierDetailPage } from "@/pages/SupplierDetailPage";
import { SupplierEditorPage } from "@/pages/SupplierEditorPage";
import { QuotationsPage } from "@/pages/QuotationsPage";
import { QuotationDetailPage } from "@/pages/QuotationDetailPage";
import { QuotationEditorPage } from "@/pages/QuotationEditorPage";
import { ReleasesPage } from "@/pages/ReleasesPage";
import { UsersPage } from "@/pages/UsersPage";
import { LandingRedirect, RequirePermission } from "@/components/shell/RequirePermission";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    element: <RequireAuth />,
    children: [
      {
        path: "/",
        element: <AppLayout />,
        children: [
          { index: true, element: <LandingRedirect><DashboardPage /></LandingRedirect> },
          { path: "releases", element: <ReleasesPage /> },
          { path: "customers", element: <CustomersPage /> },
          {
            element: <RequirePermission perm="records:create" />,
            children: [{ path: "customers/new", element: <CustomerEditorPage /> }],
          },
          {
            element: <RequirePermission perm="records:update" />,
            children: [{ path: "customers/:id/edit", element: <CustomerEditorPage /> }],
          },
          { path: "customers/:id", element: <CustomerDetailPage /> },
          { path: "proforma-invoices", element: <ProformaInvoicesPage /> },
          { path: "red-pi", element: <RedPiPage /> },
          { path: "proforma-invoices/new", element: <ProformaInvoiceEditorPage /> },
          { path: "proforma-invoices/:id", element: <ProformaInvoiceDetailPage /> },
          { path: "proforma-invoices/:id/edit", element: <ProformaInvoiceEditorPage /> },
          {
            element: <RequirePermission perm="users:manage" />,
            children: [{ path: "users", element: <UsersPage /> }],
          },
          // Remaining Option-2 modules — IA in place, build per roadmap.
          {
            element: <RequirePermission perm="analytics:view" />,
            children: [{ path: "analytics", element: <AnalyticsPage /> }],
          },
      {
            element: <RequirePermission perm="supplier_cost:view" />,
            children: [{ path: "profit", element: <ProfitPage /> }],
          },
      // Tình trạng PI: KHÔNG gác sau supplier_cost:view — đây đúng là trang cho
      // người không được xem giá.
      { path: "pi-status", element: <PiStatusPage /> },
      { path: "products", element: <ProductsPage /> },
      { path: "products/new", element: <ProductEditorPage /> },
      { path: "products/:id/edit", element: <ProductEditorPage /> },
      { path: "products/:id/stock", element: <ProductStockPage /> },
      { path: "products/:id", element: <ProductDetailPage /> },
      { path: "suppliers", element: <SuppliersPage /> },
      {
        element: <RequirePermission perm="records:create" />,
        children: [{ path: "suppliers/new", element: <SupplierEditorPage /> }],
      },
      {
        element: <RequirePermission perm="records:update" />,
        children: [{ path: "suppliers/:id/edit", element: <SupplierEditorPage /> }],
      },
      { path: "suppliers/:id", element: <SupplierDetailPage /> },
      { path: "invoices", element: <InvoicesPage /> },
      { path: "invoices/new", element: <InvoiceEditorPage /> },
      { path: "invoices/:id/edit", element: <InvoiceEditorPage /> },
      { path: "invoices/:id", element: <InvoiceDetailPage /> },
      { path: "quotations", element: <QuotationsPage /> },
      { path: "quotations/new", element: <QuotationEditorPage /> },
      { path: "quotations/:id", element: <QuotationDetailPage /> },
      { path: "quotations/:id/edit", element: <QuotationEditorPage /> },
      { path: "packing-lists", element: <PackingListsPage /> },
      { path: "packing-lists/new", element: <PackingListEditorPage /> },
      { path: "packing-lists/:id", element: <PackingListDetailPage /> },
      { path: "packing-lists/:id/edit", element: <PackingListEditorPage /> },
      { path: "delivery-notes", element: <DeliveryNotesPage /> },
      { path: "delivery-notes/new", element: <DeliveryNoteEditorPage /> },
      { path: "delivery-notes/:id", element: <DeliveryNoteDetailPage /> },
      { path: "delivery-notes/:id/edit", element: <DeliveryNoteEditorPage /> },
      { path: "statement", element: <StatementPage /> },
      { path: "purchase-orders", element: <PurchaseOrdersPage /> },
      { path: "purchase-orders/new", element: <PurchaseOrderEditorPage /> },
      { path: "purchase-orders/:id", element: <PurchaseOrderEditorPage /> },
      { path: "sample-orders", element: <SampleOrdersPage /> },
      { path: "sample-orders/new", element: <SampleOrderEditorPage /> },
      { path: "sample-orders/:id", element: <SampleOrderEditorPage /> },
      { path: "sample-cards", element: <SampleCardsPage /> },
      { path: "sample-cards/new", element: <SampleCardEditorPage /> },
      { path: "sample-cards/:id/edit", element: <SampleCardEditorPage /> },
      { path: "sample-cards/:id", element: <SampleCardDetailPage /> },
      { path: "warehouse", element: <WarehousePage /> },
      { path: "warehouse-locations", element: <WarehouseLocationsPage /> },
      { path: "warehouse/receipts/new", element: <WarehouseReceiptPage /> },
      { path: "warehouse/receipts/:id", element: <WarehouseReceiptPage /> },
      // Keep unfinished modules visible in navigation; cover direct/deep links too.
      { path: "production", element: <ProductionPage /> },
      { path: "production/materials", element: <ProductionMaterialsPage /> },
      { path: "production/materials/new", element: <ProductionMaterialPage /> },
      { path: "production/materials/:id", element: <ProductionMaterialPage /> },
      { path: "production/execution", element: <ProductionExecutionListPage /> },
      { path: "production/execution/new", element: <ProductionExecutionDocumentPage /> },
      { path: "production/execution/inspections/:id", element: <InspectionDetailPage /> },
      { path: "production/execution/:id", element: <ProductionExecutionDocumentPage /> },
      { path: "production/subcontract/:id", element: <SubcontractOrderPage /> },
      { path: "production/subcontract", element: <SubcontractPage /> },
      { path: "production/resources", element: <ProductionResourcesPage /> },
      { path: "production/resources/new", element: <ProductionResourcePage /> },
      { path: "production/resources/:id", element: <ProductionResourcePage /> },
      { path: "production/new", element: <ProductionEditorPage /> },
      { path: "production/:id", element: <ProductionEditorPage /> },
      { path: "production/:id/execution", element: <ProductionExecutionPage /> },
      { path: "quality", element: <QualityPage /> },
      { path: "quality/ncr", element: <NcrPage /> },
      { path: "quality/specs", element: <QualitySpecsPage /> },
      { path: "quality/specs/new", element: <QualitySpecEditorPage /> },
      { path: "quality/specs/:id", element: <QualitySpecEditorPage /> },
      { path: "quality/new", element: <IqcEditorPage /> },
      { path: "quality/:id", element: <IqcEditorPage /> },
      { path: "finance", element: <FinancePage /> },
      { path: "finance/*", element: <FinancePage /> },
      { path: "kpis", element: <KpisPage /> },
      { path: "p-process", element: <PProcessPage /> },
      { path: "order-process", element: <OrderProcessPage /> },
      { path: "portal", element: <PortalPage /> },
      { path: "devices", element: <DevicesPage /> },
      { path:"sourcing",element:<SourcingPage/> },
      { path:"sourcing/new",element:<SourcingEditorPage/> },
      { path:"sourcing/requisitions/:prId",element:<SourcingProgressPage/> },
      { path:"sourcing/orders/:id",element:<SourcingOrderPage/> },
      { path:"sourcing/:id/bids/:bidId",element:<SourcingBidPage/> },
      { path:"sourcing/:id",element:<SourcingEditorPage/> },
      { path:"mrp",element:<MrpPage/> },
      { path:"mrp/runs",element:<MrpRunsPage/> },
      { path:"mrp/runs/:id",element:<MrpRunPage/> },
      { path:"unit-pricing",element:<UnitPricingPage/> },
      { path:"unit-pricing/new",element:<UnitPricingEditorPage/> },
      { path:"unit-pricing/:id",element:<UnitPricingEditorPage/> },
      { path:"routings",element:<RoutingsPage/> },
      { path:"routings/new",element:<RoutingEditorPage/> },
      { path:"routings/:id",element:<RoutingEditorPage/> },
      { path: "boms", element: <BomsPage /> },
      { path: "boms/new", element: <BomEditorPage /> },
      { path: "boms/:id", element: <BomEditorPage /> },
      { path:"sales-orders/opportunities",element:<OpportunitiesPage/> },
      { path:"sales-orders/opportunities/new",element:<OpportunityEditorPage/> },
      { path:"sales-orders/opportunities/:id",element:<OpportunityEditorPage/> },
      { path:"sales-orders",element:<SalesOrdersPage/> },
      { path:"sales-orders/new",element:<SalesOrderEditorPage/> },
      { path:"sales-orders/:id",element:<SalesOrderEditorPage/> },
      { path:"purchase-requisitions",element:<RequisitionsPage/> },
      { path:"purchase-requisitions/new",element:<RequisitionEditorPage/> },
      { path:"purchase-requisitions/:id",element:<RequisitionEditorPage/> },
      { path: "stock-moves", element: <StockTransfersPage /> },
      { path: "stock-moves/reservations", element: <StockReservationsPage /> },
      { path: "stock-moves/counts", element: <StockCountsPage /> },
      { path: "stock-moves/sales", element: <StockSalesPage /> },
      { path: "stock-moves/new", element: <StockTransferEditorPage /> },
      { path: "stock-moves/:id", element: <StockTransferEditorPage /> },
      { path: "gl-accounts/*", element: <ComingSoonPage titleKey="nav.glAccounts" /> },
      { path: "service-tickets/new", element: <ServiceTicketEditorPage/> },
    { path: "service-tickets/:id", element: <ServiceTicketEditorPage/> },
    { path: "service-tickets", element: <ServiceTicketsPage /> },
      { path: "service-tickets/*", element: <ServiceTicketsPage /> },
      { path: "supplier-claims/new", element: <SupplierClaimEditorPage /> },
      { path: "supplier-claims/:id", element: <SupplierClaimEditorPage /> },
      { path: "supplier-claims", element: <SupplierClaimsPage /> },
      {
            element: <RequirePermission perm="settings:manage" />,
            children: [{ path: "settings", element: <SettingsPage /> }],
          },
      {
            element: <RequirePermission perm="deleted:manage" />,
            children: [{ path: "deleted-records", element: <DeletedRecordsPage /> }],
          },
      { path: "*", element: <Navigate to="/" replace /> },
        ],
      },
    ],
  },
]);
